import React from 'react';
import personalContent from '../Content/PersonalContent';
import ProjectContainer from './ProjectContainer';
import EditorChrome from './EditorChrome';

class Personal extends React.Component
{
    render()
    {
        return (
            <main className="container portfolio-shell inner-shell">
                <EditorChrome active="/Archive" />
                <section className="inner-editor archive-index-page Personal">
                            <a className="back-link" href="/">Back home</a>
                            <h1>Personal Project Archive</h1>
                            <p className="archive-intro">
                                Games, PCB experiments, and side projects from earlier work. They stay here as a record of
                                breadth, prototyping, and hands-on making.
                            </p>
                            <ProjectContainer projectTiles={personalContent}/>
                </section>
            </main>
        );
    }

}

export default Personal;
